<template>
  <section>
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        Learning Areas Overview&nbsp;
      </h1>
      <report-overview />
      <v-card class="filter-report pa-4 mb-3 mt-3">
        <h2 class="pb-2">Learning Area Report</h2>
        <v-row row wrap>
          <v-col sm="6" cols="12">
            <v-select
              :items="headers"
              v-model="selected"
              label="Choose reporting metrics"
              multiple
              return-object
              dense
              class="pr-3"
            >
              <template v-slot:selection="{ item }">
                <v-chip x-small>
                  <span>{{ item.text }}</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col v-if="hasDataset" sm="2" cols="12" class="px-0 pt-6">
            <v-select
              :items="dataVersion"
              v-model="selectVersion"
              label="Pre 16 Feb 2021"
              dense
              class="pl-3 mr-5"
            >
            </v-select>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0" style="margin-left: -3%;">
            <report-date-picker
              :prop-date-from="dateFrom"
              :prop-date-to="dateTo"
              :prop-date-min="dateMin"
              :prop-date-max="dateMax"
              @dateToSelected="dateToSelected"
              @dateFromSelected="dateFromSelected"
            />
          </v-col>
        </v-row>
        <report-data-table
          @csvExport="csvExport"
          :headers="selected"
          :items="items"
          :loading="loading"
        />
      </v-card>
    </v-container>
  </section>
</template>

<script>
import ReportOverview from '../ReportOverview'
import ReportDataTable from '../ReportDataTable'
import ReportDatePicker from '../ReportDatePicker'
import ReportsMixin from '../reports-mixin'
import FileMixin from '../file-mixin'
import Config from '@/modules/config/models/Config'

export default {
  components: {
    ReportOverview,
    ReportDataTable,
    ReportDatePicker
  },
  mixins: [ReportsMixin, FileMixin],
  async mounted() {
    this.loading = false
    this.type = 'learningArea' // type is a mixin attribute
    if (this.$store.state.isSDECC == 1) {
      if (this.headers[5].text === 'Students % improvement') {
        this.headers[5].text = '% improvement'
      }
    }
    this.setDataset()
    await this.searchItems()
  },
  methods: {
    setDataset() {
      let datasetDate = Config.value('datasetDate')
      let currentDateFrom = this.$moment(this.dateFrom)
      let currentDateTo = this.$moment(this.dateTo)
      let currentdatasetDate = this.$moment(datasetDate)

      if (datasetDate) {
        if (this.selectVersion === 'No') {
          this.dateMin = datasetDate
          this.dateMax = null

          if (currentDateFrom < currentdatasetDate) this.dateFrom = datasetDate
          if (currentDateTo < currentdatasetDate) this.dateTo = datasetDate
        } else {
          this.dateMax = datasetDate
          this.dateMin = null

          if (currentDateFrom > currentdatasetDate) this.dateFrom = datasetDate
          if (currentDateTo > currentdatasetDate) this.dateTo = datasetDate
        }
      }
    }
  },
  watch: {
    selectVersion(val) {
      let datasetDate = Config.value('datasetDate')
      let currentDateFrom = this.$moment(this.dateFrom)
      let currentDateTo = this.$moment(this.dateTo)
      let currentdatasetDate = this.$moment(datasetDate)

      if (datasetDate) {
        if (val === 'No') {
          this.dateMin = datasetDate
          this.dateMax = null

          if (currentDateFrom <= currentdatasetDate) this.dateFrom = datasetDate
          if (currentDateTo <= currentdatasetDate)
            this.dateTo = this.$moment.today
        } else {
          this.dateMax = this.$moment(datasetDate)
            .subtract(1, 'days')
            .format('YYYY-MM-DD')
          this.dateMin = null

          if (currentDateFrom >= currentdatasetDate)
            this.dateFrom = this.$moment(datasetDate)
              .subtract(1, 'days')
              .format('YYYY-MM-DD')
          if (currentDateTo > currentdatasetDate) this.dateTo = this.dateMax
        }
      }
    }
  },
  computed: {
    hasDataset() {
      return Config.value('datasetDate')
    },
    dataVersion() {
      return ['Yes', 'No']
    }
  },
  data() {
    return {
      selectVersion: 'No',
      modal: false,
      loading: false,
      dateMin: null,
      dateMax: null,
      selected: [
        {
          text: 'Learning Area Name',
          value: 'name'
        },
        {
          text: 'No. of Attempts PreQuiz',
          value: 'pre_quiz_attempts',
          align: 'center'
        },
        {
          text: 'No. of Attempts PostQuiz',
          value: 'post_quiz_attempts',
          align: 'center'
        },
        {
          text: '% Understanding PreQuiz',
          value: 'pre_quiz_understanding',
          align: 'center'
        },
        {
          text: '% Understanding PostQuiz',
          value: 'post_quiz_understanding',
          align: 'center'
        },
        {
          text: 'Students % improvement',
          value: 'improvement',
          align: 'center'
        }
      ],
      headers: [
        {
          text: 'Learning Area Name',
          value: 'name'
        },
        {
          text: 'No. of Attempts PreQuiz',
          value: 'pre_quiz_attempts',
          align: 'center'
        },
        {
          text: 'No. of Attempts PostQuiz',
          value: 'post_quiz_attempts',
          align: 'center'
        },
        {
          text: '% Understanding PreQuiz',
          value: 'pre_quiz_understanding',
          align: 'center'
        },
        {
          text: '% Understanding PostQuiz',
          value: 'post_quiz_understanding',
          align: 'center'
        },
        {
          text: 'Students % improvement',
          value: 'improvement',
          align: 'center'
        }
      ],
      items: []
    }
  }
}
</script>

<style lang="scss">
.filter-report {
  width: 100%;

  h2 {
    display: block;
    width: 100%;
  }

  p {
    padding: 0;
    margin: 0;
  }
}
</style>
